import React from 'react';

const BonusesTab = ({ user, updateUser }) => (
  <div className="admin-section">
    <h2>Бонусные программы</h2>
    <div className="admin-cards-row admin-cards-row-3">
      <div className="admin-card-group">
        <h3>Приветственный</h3>
        <label className="admin-field admin-checkbox">
          <input type="checkbox" checked={!!user.welcomeBonusEnabled} onChange={(e) => updateUser('welcomeBonusEnabled', e.target.checked)} />
          <span>При первой регистрации</span>
        </label>
        <label className="admin-field">
          <span>Сумма бонуса</span>
          <input type="number" min="0" value={user.welcomeBonusAmount ?? 0} disabled={!user.welcomeBonusEnabled} onChange={(e) => updateUser('welcomeBonusAmount', Number(e.target.value))} />
        </label>
      </div>

      <div className="admin-card-group">
        <h3>День рождения</h3>
        <label className="admin-field admin-checkbox">
          <input type="checkbox" checked={!!user.birthdayBonusEnabled} onChange={(e) => updateUser('birthdayBonusEnabled', e.target.checked)} />
          <span>Начислять бонус</span>
        </label>
        <label className="admin-field admin-checkbox">
          <input type="checkbox" checked={!!user.collectBirthDate} disabled={!user.birthdayBonusEnabled} onChange={(e) => updateUser('collectBirthDate', e.target.checked)} />
          <span>Спрашивать дату при регистрации</span>
        </label>
        <label className="admin-field">
          <span>Сумма</span>
          <input type="number" min="0" value={user.birthdayBonusAmount ?? 0} disabled={!user.birthdayBonusEnabled} onChange={(e) => updateUser('birthdayBonusAmount', Number(e.target.value))} />
        </label>
        <label className="admin-field">
          <span>За N дней до ДР</span>
          <input type="number" min="0" value={user.birthdayBonusDaysBefore ?? 0} disabled={!user.birthdayBonusEnabled} onChange={(e) => updateUser('birthdayBonusDaysBefore', Number(e.target.value))} />
        </label>
      </div>

      <div className="admin-card-group">
        <h3>Реферальная</h3>
        <label className="admin-field admin-checkbox">
          <input type="checkbox" checked={!!user.referralEnabled} onChange={(e) => updateUser('referralEnabled', e.target.checked)} />
          <span>«Приведи друга»</span>
        </label>
        <p className="admin-hint">У каждого клиента уникальный код на обороте карты в Telegram</p>
        <label className="admin-field">
          <span>Бонус пригласившему</span>
          <input type="number" min="0" value={user.referralBonusReferrer ?? 0} disabled={!user.referralEnabled} onChange={(e) => updateUser('referralBonusReferrer', Number(e.target.value))} />
        </label>
        <label className="admin-field">
          <span>Бонус новому</span>
          <input type="number" min="0" value={user.referralBonusReferred ?? 0} disabled={!user.referralEnabled} onChange={(e) => updateUser('referralBonusReferred', Number(e.target.value))} />
        </label>
      </div>
    </div>
  </div>
);

export default BonusesTab;
